// extracted by mini-css-extract-plugin
module.exports = {"selectWrap":"SelectArea_selectWrap__2jd9n","selcetText":"SelectArea_selcetText__1m1dX"};